export const environment = {
  childModuleUris: {
    auth: 'https://prod-backoffice-auth-a4e8g7gqhhfwd8da.a03.azurefd.net/',
    postdispatch: 'https://picupprodpostdispatchmf.azureedge.net/',
    drivermanagement: 'https://prod-backoffice-driverman-hbdghra5ffabbfed.a03.azurefd.net/',
    zones: 'https://prod-backoffice-zones-cbbkd2e8gtcwdkcp.a03.azurefd.net/',
    financials: 'https://prod-backoffice-financials-fjg0esg4bfefcjey.a03.azurefd.net/',
    reports: 'https://prod-backoffice-reports-hehmfabkgsdkeffk.a03.azurefd.net/',
    cartracktracker: 'https://cartracktrackerproduction.azureedge.net/',
    admin: 'https://prod-backoffice-admin-b5ddcwbvgtgxczdq.a03.azurefd.net/',
    ordermanagement: 'https://prod-backoffice-orderman-egdggchhe5buhxea.a03.azurefd.net/',
    banking: 'https://prod-backoffice-banking-b6h2f3bsgxgmf7b4.a03.azurefd.net/'
  },
  firebase: {
    apiKey: 'AIzaSyBK5qBHhWkdgpJSrlpG8uZfyLWLRtoSugw',
    authDomain: 'picup-production.firebaseapp.com',
    databaseURL: 'https://picup-production.firebaseio.com/',
    projectId: 'picup-production',
    storageBucket: 'picup-production.appspot.com',
    messagingSenderId: '461246791837',
    refreshTokenUrl: 'https://securetoken.googleapis.com/v1'
  }
};
